import { Group, Text, Transformer, Rect } from 'react-konva';
import { Html } from 'react-konva-utils';
import FunctionalityText from './Functionality/TextFunctionality';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TextComponent = ({
    text,
    index,
    selectedShapeId,
    handleDragMove,
    handleShapeClick,
    currentStage,
    setStageProperties,
    setShapeHeight,
    setShapeWidth,
}) => {
    const {
        isEditing,
        editedText,
        MAX_WIDTH,
        MAX_HEIGHT,
        shapeRef,
        handleDoubleClick,
        setEditing,
        trRef,
        inputRef,
        handleTextChange,
        handleTextBlur,
        handleTextFocus,
        handleKeyDown,
    } = FunctionalityText({ selectedShapeId, setStageProperties, currentStage, index, text });
    return (
        <Group key={text.id}>
            {!isEditing && (
                <Text
                    x={Math.round(text.x)}
                    y={Math.round(text.y)}
                    text={editedText}
                    fontSize={text.fontSize}
                    fontFamily={text.fontFamily}
                    fontStyle={text.fontStyle}
                    textDecoration={text.textDecoration}
                    fill={text.fill}
                    align={text.align}
                    width={Math.min(text.width, MAX_WIDTH)}
                    height={Math.min(text.height, MAX_HEIGHT)}
                    wrap='word'
                    id={text.id}
                    ref={shapeRef}
                    draggable={!isEditing}
                    editable={isEditing}
                    onDragMove={(e) => handleDragMove(e, index)}
                    onClick={() => handleShapeClick(text.id, 'texts')}
                    onDblClick={handleDoubleClick}
                    onTap={() => handleShapeClick(text.id, 'texts')}
                    onTransformEnd={(e) => {
                        const node = shapeRef.current;

                        const newWidth = Math.min(Math.round(node.width() * node.scaleX()), MAX_WIDTH);
                        const newHeight = Math.min(Math.round(node.height() * node.scaleY()), MAX_HEIGHT);

                        node.width(newWidth);
                        node.height(newHeight);
                        node.scaleX(1);
                        node.scaleY(1);

                        const newX = Math.round(node.x());
                        const newY = Math.round(node.y());

                        setShapeHeight(newHeight);
                        setShapeWidth(newWidth);

                        setStageProperties((prevProperties) => {
                            const currentProperties = prevProperties[currentStage];
                            const updatedTexts = [...currentProperties.combinedObject];

                            updatedTexts[index] = {
                                ...updatedTexts[index],
                                width: newWidth,
                                height: newHeight,
                                x: newX,
                                y: newY,
                                rotation: node.rotation(),
                            };

                            return {
                                ...prevProperties,
                                [currentStage]: {
                                    ...currentProperties,
                                    combinedObject: updatedTexts,
                                },
                            };
                        });

                        setEditing(false);
                    }}
                />
            )}

            {text.id === selectedShapeId && <Transformer ref={trRef} centeredScaling={true} rotateEnabled={true} />}
            {isEditing && shapeRef.current && (
                <Rect
                    width={shapeRef.current.width() ?? 16}
                    height={shapeRef.current.height() ?? 16}
                    fill='transparent'
                    onMouseDown={(e) => e.evt.preventDefault()}
                />
            )}

            {isEditing && (
                <Html
                    divProps={{
                        style: {
                            position: 'absolute',
                            top: 10,
                            left: 10,
                        },
                    }}
                >
                    <input
                        ref={inputRef}
                        type='text'
                        value={editedText}
                        onChange={handleTextChange}
                        onBlur={handleTextBlur}
                        onFocus={handleTextFocus}
                        onKeyDown={handleKeyDown}
                        style={{
                            position: 'absolute',
                            top: text.y,
                            left: text.x,
                            fontSize: text.fontSize,
                            color: text.fill,
                            width: shapeRef.current ? shapeRef.current.width() : 'auto',
                            height: shapeRef.current ? shapeRef.current.height() : 'auto',
                            border: 'none',
                            padding: 0,
                            margin: 0,
                            outline: 'none',
                            backgroundColor: 'transparent',
                        }}
                    />
                </Html>
            )}
            {isEditing && (
                <Transformer
                    ref={trRef}
                    centeredScaling={true}
                    boundBoxFunc={(oldBox, newBox) => {
                        if (newBox.width > MAX_WIDTH || newBox.height > MAX_HEIGHT) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}
        </Group>
    );
};

export default TextComponent;
